import constants from '../constants';
import RGBColor from '../classes/rgb-color';

const { COMMON } = constants;
const normalizeRGB = (rgbColor) => {
  const { red, green, blue, alpha } = rgbColor;
  return 1 - alpha < COMMON.ACCURACY ? rgbColor : new RGBColor(red, green, blue);
};

export default normalizeRGB;
